export default "__VITE_ASSET__CvR8hCdA__"